import { match, matchPath } from 'react-router'
import { createSelector } from 'reselect'
import {
  AccountVirtualCardsMatchParams,
  accountVirtualCardsRouteProps,
} from 'src/navigation/routeProps'
import { RootState } from 'src/redux/createRootReducer'
import {
  selectCreditCardListModelsFromState,
  selectCreditCardPermissionsModelsFromState,
} from 'src/redux/selectors/data/creditCards.selectors'
import { selectVirtualCardListModels } from 'src/redux/selectors/data/virtualCards.selectors'
import { selectCalculatedBackgroundLocation } from 'src/redux/selectors/router.selectors'
import { UsersFullPaginatedDataState } from 'src/redux/usersFullPaginatedData.reducer'
import { VirtualCardsFullPaginatedDataState } from 'src/redux/virtualCardsFullPaginatedData.reducer'

export const selectCreditCardIdFromRoute = createSelector(
  [selectCalculatedBackgroundLocation],
  (backgroundLocation) => {
    const mtch = matchPath<AccountVirtualCardsMatchParams>(
      backgroundLocation.pathname,
      accountVirtualCardsRouteProps,
    ) as match<AccountVirtualCardsMatchParams>
    return mtch.params.id
  },
)

export const selectCreditCard = createSelector(
  [selectCreditCardListModelsFromState, selectCreditCardIdFromRoute],
  (creditCards, creditCardId) => {
    return creditCards[creditCardId] !== undefined
      ? creditCards[creditCardId]
      : undefined
  },
)

export const selectCreditCardPermissions = createSelector(
  [selectCreditCardPermissionsModelsFromState, selectCreditCardIdFromRoute],
  (creditCardPermissions, creditCardId) => {
    return creditCardPermissions[creditCardId] !== undefined
      ? creditCardPermissions[creditCardId]
      : undefined
  },
)

export const selectUsersFullPaginatedDataFromState = (
  state: RootState,
): UsersFullPaginatedDataState =>
  state.app.account.accountVirtualCards.usersFullPaginatedData

export const selectVirtualCardsFullPaginatedData = (
  state: RootState,
): VirtualCardsFullPaginatedDataState =>
  state.app.account.accountVirtualCards.virtualCardsFullPaginatedData

const selectUniqueVirtualCardIds = createSelector(
  [selectVirtualCardsFullPaginatedData],
  (data) => data.ids.filter((id, i) => data.ids.indexOf(id) === i),
)
const selectUniqueVirtualCardListModels = createSelector(
  [selectUniqueVirtualCardIds, selectVirtualCardListModels],
  (ids, virtualCards) => ids.map((id) => virtualCards[id]),
)
export const selectFilteredVirtualCards = createSelector(
  [selectUniqueVirtualCardListModels, selectCreditCardIdFromRoute],
  (virtualCards, creditCardId) =>
    virtualCards.filter((vc) => vc.creditCardId === creditCardId),
)
